import { getLocalOrder, updateLocalOrder } from "./db";
import { removeProvisionalLoyaltyRedemption } from "./loyalty-provisional";
import {
  buildLocalPricingSnapshot,
  type LocalPricingBaseTotals,
} from "./local-pricing-snapshot";
import type { LocalOrderRecord } from "./types";

/** True when checkout pricing actually included a loyalty reward discount. */
export function localOrderHasReward(order: LocalOrderRecord): boolean {
  return (order.discountBreakdown ?? []).some(
    (item) => item.source === "loyalty_reward",
  );
}

/**
 * ລຶບການແລກລາງວັນອອກຈາກ local order (OPEN ເທົ່ານັ້ນ) ແລະຄິດຍອດໃໝ່ຈາກ coupon/voucher ທີ່ເຫຼືອ
 */
export async function clearLocalOrderReward(
  clientOrderId: string,
  base: LocalPricingBaseTotals,
): Promise<LocalOrderRecord | undefined> {
  const existing = await getLocalOrder(clientOrderId);
  if (!existing) {
    return undefined;
  }
  if (existing.status !== "OPEN") {
    throw new Error("ສາມາດຖອນລາງວັນໄດ້ພຽງ order ທີ່ຍັງ OPEN");
  }
  if (!localOrderHasReward(existing)) {
    return existing;
  }

  const pricing = buildLocalPricingSnapshot({
    base,
    couponSnapshots: existing.couponSnapshots ?? [],
    voucherSnapshots: existing.voucherSnapshots ?? [],
  });

  removeProvisionalLoyaltyRedemption(clientOrderId);

  const updated = await updateLocalOrder(clientOrderId, {
    rewardSnapshot: undefined,
    rewardId: undefined,
    couponSnapshots: pricing.couponSnapshots,
    voucherSnapshots: pricing.voucherSnapshots,
    discountBreakdown: pricing.discountBreakdown,
    totals: pricing.totals,
    pricingSource: pricing.pricingSource,
  });

  return updated;
}
